import { Department } from "../../../domain/department";
import { StringFilterParameter } from "../../system/filters";

export class DepartmentFilterParameter {
  constructor(name: string = "", id: string = "") {
    this.name = new StringFilterParameter(name);
    this.id = new StringFilterParameter(id, false);
  }

  name: StringFilterParameter;
  id: StringFilterParameter;

  filter(source: Department): boolean {
    return this.name.filter(source.name) && this.id.filter(source.id);
  }

  clear(): void {
    this.name.keyword = "";
    this.id.keyword = "";
  }

  clone(): DepartmentFilterParameter {
    return new DepartmentFilterParameter(this.name.keyword, this.id.keyword);
  }
}
